import { UserAgent } from '@quentin-sommer/react-useragent';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, Text, Flex } from 'rebass';
import styled from '@emotion/styled';

import { IoVideocamOutline } from "react-icons/io5";
import RecordChatButton from 'chats/record-chat-button';
import { checkIsIpadUser } from 'story-media/hooks';

export const VideoUploadLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: ${props => props.theme.fonts.sanFrancisco};
  position: relative;
  color: ${props => props.theme.colors.brand};
  cursor: pointer;
  width:100%;
  height:inherit;
  input {
    position: absolute;
    left: -9999em;
  }
`;

const Outer = styled.div`
  position: relative;
`;

const BigSelfieButton = ({ handleChange }) => {
  const isIpadUser = checkIsIpadUser();
  return (
    <UserAgent mobile>
      {isMobile => (
        <>
          <Outer>
            {isMobile || isIpadUser ?
              <VideoUploadLabel htmlFor="selfie_video">
                <input
                  type="file"
                  id="selfie_video"
                  capture="user"
                  accept="video/*"
                  onChange={(e) => handleChange(e, true)}
                />
                <Flex sx={{ cursor: 'pointer' }} justifyContent="space-between" width="100%" alignItems="center">
                  <Flex alignItems="center">
                    <Flex height="max-content" mr={1} justifyContent="center" alignItems="center" bg="#EFFFF5" p="14px" sx={{ borderRadius: '50%' }}>
                      <Box as={IoVideocamOutline} color="#2E9E58" minWidth={24} size={24} />
                    </Flex>
                    <Text fontFamily="Poppins" fontSize={18} lineHeight="165%" fontWeight={500} color="#0E0E0E" >
                      Video Recording
                    </Text>
                  </Flex>
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                    <path d="M0.514648 2.34292L1.92885 0.928711L8.99995 7.99975L1.92885 15.0709L0.514648 13.6567L6.17155 7.99975L0.514648 2.34292Z" fill="#64748B" />
                  </svg>
                </Flex>
                {/* <Box
                  fontWeight="normal"
                  fontSize={2}
                  flex={1}
                  textAlign="center"
                  p={3}
                  bg="#F5EEF8"
                  color="#64748B"
                  sx={{ borderRadius: 12, border: '1px dashed #9B59B6' }}
                >
                  <Text m="auto" as={LuVideo} color="#64748B" size={24} />
                  <Text fontFamily="Poppins" fontSize={16} lineHeight="24px" color="#64748B" >Video</Text>
                </Box> */}
              </VideoUploadLabel>
              :
              <RecordChatButton isFromRecordVideo handleChange={handleChange} />
            }
          </Outer>
        </>
      )}
    </UserAgent>
  )
};

BigSelfieButton.propTypes = {
  handleChange: PropTypes.func.isRequired,
};

export default BigSelfieButton;
